module.exports = __webpack_public_path__ + "img/yellow-bg.29f48e72.png";